import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=52fad4b4&scoped=true&"
import script from "./DetailTable.vue?vue&type=script&lang=ts&"
export * from "./DetailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fad4b4",
  null
  
)

export default component.exports